export const fontSizes = {
  bigInch: '4rem', // 48px
  inch: '3rem', // 36px
  bigCanon: '2.75rem', // 33px
  nonpareil: '2.5rem', // 30px
  canon: '2rem', // 24px
  paragon: '1.6666666667rem', // 20px
  greatPrimer: '1.5rem', // 18px
  primer: '1.3333333333rem', // 16px
  tertiaPrime: '1.20rem', // 15px
  tertia: '1.1666666667rem', // 14px
  normal: '1rem', // 12px
  petite: '0.8333333333rem', // 10px
  minion: '0.6666666667rem', // 8px
};
